<template>
  <el-dialog
    :visible.sync="isShow"
    :title="title"
    width="50%"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
  >
    <iframe
      v-if="isShow"
      :src="encodedURL"
      style="width: 100%; height: 60vh; border: none;"
    />
  </el-dialog>
</template>
<script>
export default {
  name: 'PDFDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    pdfData: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: 'Document Viewer'
    }
  },
  computed: {
    encodedURL () {
      if (this.title === 'Label') {
        return 'data:application/pdf;base64,' + this.pdfData
      }
      return atob(this.pdfData)
    }
  }
}
</script>
<style scoped>

</style>
